import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from 'utils/actionGenerator';

export const GET_SUPPLY_DETAILS = createRequestTypes('placement/supply/GET_SUPPLY_DETAILS');
export const SEARCH_OPERATOR = createRequestTypes('placement/supply/SEARCH_OPERATOR');

export const UPDATE_FREIGHT_DETAILS = createRequestTypes('placement/supply/UPDATE_FREIGHT_DETAILS');
export const CREATE_CONSIGNMENT = createRequestTypes('placement/supply/CREATE_CONSIGNMENT');
export const UPDATE_CONSIGNMENT = createRequestTypes('placement/supply/UPDATE_CONSIGNMENT');
export const CLEAR_FLAGS = createRequestTypes('placement/supply/CLEAR_FLAGS');
export const GET_PHONE_NO = createRequestTypes('placement/supply/GET_PHONE_NO');

export const getSupplyDetails = {
  request: (params) => createAction(GET_SUPPLY_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_SUPPLY_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_SUPPLY_DETAILS[FAILURE], { response }),
  clearFlags: () => createAction(CLEAR_FLAGS),
};

export const getOperatorSearchResults = {
  request: (params) => createAction(SEARCH_OPERATOR[REQUEST], { params }),
  success: (response) => createAction(SEARCH_OPERATOR[SUCCESS], { response }),
  failure: (response) => createAction(SEARCH_OPERATOR[FAILURE], { response }),
};

export const updateFreightDetails = {
  request: (payload) => createAction(UPDATE_FREIGHT_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_FREIGHT_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_FREIGHT_DETAILS[FAILURE], { response }),
};

export const createConsignmenet = {
  request: (payload) => createAction(CREATE_CONSIGNMENT[REQUEST], { payload }),
  success: (response) => createAction(CREATE_CONSIGNMENT[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_CONSIGNMENT[FAILURE], { response }),
};

export const updateConsignment = {
  request: (payload) => createAction(UPDATE_CONSIGNMENT[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_CONSIGNMENT[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_CONSIGNMENT[FAILURE], { response }),
};

export const getPhoneNo = {
  request: (params) => createAction(GET_PHONE_NO[REQUEST], { params }),
  success: (response) => createAction(GET_PHONE_NO[SUCCESS], { response }),
  failure: (response) => createAction(GET_PHONE_NO[FAILURE], { response }),
};
